"use client";

import React from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = ["Trockenbau & individueller Innenausbau", "Professionelle Bodenlegearbeiten", "Hochwertige Maler- & Lackierarbeiten", "Moderne Akustik- & Deckensysteme"];
export default function ServicesGridAusbauarbeiten() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="services-grid-ausbauarbeiten" className="bg-background py-12 md:py-16 overflow-hidden">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={imageRef} className={`w-full transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <AspectRatio ratio={4 / 3} className="bg-muted rounded-lg overflow-hidden shadow-md">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/interior_finishing_service.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/interior_finishing_service.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/interior_finishing_service.png-wvc-sizes" alt="Professionelle Ausbauarbeiten" className="object-cover w-full h-full" loading="lazy" src="https://renovierungen-schneider.de/wp-content/uploads/2026/05/41807ac5-a1f4-41e5-9129-0da8e099e111.jpg" />
            </AspectRatio>
          </div>

          {}
          <div ref={textRef} className={`flex flex-col gap-6 transition-all duration-1000 ease-out delay-200 ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div>
              <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Ausbauarbeiten
              </h2>
              <p className="text-muted-foreground text-lg leading-relaxed">
                Wir verwandeln Ihre Räumlichkeiten nach Ihren individuellen Vorstellungen. 
                Mit höchster Präzision, erstklassigen Materialien und langjähriger Erfahrung 
                sorgen wir für einen reibungslosen Ablauf und perfekte Ergebnisse bei jedem 
                Ausbauprojekt.
              </p>
            </div>

            <ul className="flex flex-col gap-3 mb-2">
              {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <div className="mt-1 bg-primary/10 p-1 rounded-md shrink-0">
                    <Check className="size-4 text-primary" />
                  </div>
                  <span className="text-foreground font-medium">{feature}</span>
                </li>)}
            </ul>

            <div className="pt-2">
              <Button asChild size="lg" className="w-full sm:w-fit">
                <Link to="/ServicesPage">
                  Jetzt anfragen
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}